import { IGameData } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IEvent, createGridOffsetChangedEvent } from 'js/bubbleCore/events';
import { fillRow } from 'js/bubbleCore/handlers/fillRow';
import { moveGridBubblesDown } from 'js/bubbleCore/handlers/moveGridBubblesDown';
import { BubbleFactory } from 'js/bubbleCore/bubbles/BubbleFactory';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop'
import { linear } from 'framework/utils/math-utils';

export function scrollGrid(data: IGameData, factory: BubbleFactory, events: IEvent[]): void {
  const { grid } = data;
  grid.offset.y += grid.scrollSpeed;

  const lowestBubble = Object.values(data.grid.values).reduce((lowestRow, bubble) => {
    return Math.max(lowestRow, bubble.row);
  }, 0);

  grid.scrollSpeed = linear(
    grid.scrollSpeed,
    lowestBubble < grid.scrollFill ? grid.fillScrollSpeed : grid.normalScrollSpeed,
    0.02,
  )

  if (grid.offset.y >= 0) {
    moveGridBubblesDown(grid, 2, events);
    fillRow(data, factory, 0, events);
    fillRow(data, factory, 1, events);
    grid.offset.y -= 2 * (isPointyTop(grid.type) ? 3/4 : 1);
  }
  events.push(createGridOffsetChangedEvent(grid));
}